import { Engine1Proxy, ConciergeProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import AxiosManager from '../../../Common/Managers/AxiosManager';
import GetApiUrlsHelper from '../../../Common/Helpers/GetApiUrlsHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const ASIENTOSCONTABLES_ACTUALIZAR_DATOSEXCEL = "ASIENTOSCONTABLES_ACTUALIZAR_DATOSEXCEL";
export const ASIENTOSCONTABLES_ACTUALIZAR_FECHA = "ASIENTOSCONTABLES_ACTUALIZAR_FECHA";
export const ASIENTOSCONTABLES_ACTUALIZAR_FECHA_SELECTOR ="ASIENTOSCONTABLES_ACTUALIZAR_FECHA_SELECTOR";
export const ASIENTOSCONTABLES_ACTUALIZAR_MENSAJE_ERROR = "ASIENTOSCONTABLES_ACTUALIZAR_MENSAJE_ERROR";
export const ASIENTOSCONTABLES_CAMBIAR_CHECK = "ASIENTOSCONTABLES_CAMBIAR_CHECK";
export const ASIENTOSCONTABLES_CAMBIAR_VALOR_INPUT = "ASIENTOSCONTABLES_CAMBIAR_VALOR_INPUT";
export const ASIENTOSCONTABLES_SELECCIONAR_OPCION_COMBO ="ASIENTOSCONTABLES_SELECCIONAR_OPCION_COMBO";
export const ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES=  "ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES";
export const ASIENTOSCONTABLES_CARGAR_DATOS_COMBOS=  "ASIENTOSCONTABLES_CARGAR_DATOS_COMBOS";
export const ASIENTOSCONTABLES_CAMBIAR_RESULTADO ="ASIENTOSCONTABLES_CAMBIAR_RESULTADO";
export const ASIENTOSCONTABLES_CARGAR_ESTADOS_ASIENTOS = "ASIENTOSCONTABLES_CARGAR_ESTADOS_ASIENTOS";
export const ASIENTOSCONTABLES_DESPLEGAR_DATOS_ADICIONALES = "ASIENTOSCONTABLES_DESPLEGAR_DATOS_ADICIONALES";
export const ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_ASIENTO = "ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_ASIENTO";
export const ASIENTOSCONTABLES_DESPLEGAR_FILTROS = "ASIENTOSCONTABLES_DESPLEGAR_FILTROS";
export const ASIENTOSCONTABLES_FILTRAR_MODELOS = "ASIENTOSCONTABLES_FILTRAR_MODELOS";
export const ASIENTOSCONTABLES_GUARDAR_USUARIO_ACTUAL = "ASIENTOSCONTABLES_GUARDAR_USUARIO_ACTUAL";
export const ASIENTOSCONTABLES_GUARDAR_QUITAR_MODELO_SELECCIONADO  = "ASIENTOSCONTABLES_GUARDAR_QUITAR_MODELO_SELECCIONADO"
export const ASIENTOSCONTABLES_GUARDAR_VALOR_COMBO_TEMPORAL  = "ASIENTOSCONTABLES_GUARDAR_VALOR_COMBO_TEMPORAL"
export const ASIENTOSCONTABLES_MOSTRAR_MODAL = "ASIENTOSCONTABLES_MOSTRAR_MODAL";
export const ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO = "ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO";
export const ASIENTOSCONTABLES_CARGAR_PERMISOS_USUARIO = "ASIENTOSCONTABLES_CARGAR_PERMISOS_USUARIO";
export const ASIENTOSCONTABLES_OCULTAR_BOTON_VERMAS = "ASIENTOSCONTABLES_OCULTAR_BOTON_VERMAS";
export const ASIENTOSCONTABLES_MOSTRAR_SPINNER = "ASIENTOSCONTABLES_MOSTRAR_SPINNER";
export const ASIENTOSCONTABLES_SELECCIONAR_FILTRO_PROCESOS = "ASIENTOSCONTABLES_SELECCIONAR_FILTRO_PROCESOS";
export const ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO = "ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO";
export const ASIENTOSCONTABLES_ACTUALIZAR_MODELOS_MARCA = "ASIENTOSCONTABLES_ACTUALIZAR_MODELOS_MARCA";
export const ASIENTOSCONTABLES_POBLAR_GRILLA = "ASIENTOSCONTABLES_POBLAR_GRILLA";
export const ASIENTOSCONTABLES_CARGA_INICIAL_FILTRO = "ASIENTOSCONTABLES_CARGA_INICIAL_FILTRO";
export const ASIENTOSCONTABLES_CARGA_INICIAL_NUEVO_ASIENTO = "ASIENTOSCONTABLES_CARGA_INICIAL_NUEVO_ASIENTO";
export const ASIENTOSCONTABLES_CARGAR_DATOS_MODELO ="ASIENTOSCONTABLES_CARGAR_DATOS_MODELO";
export const ASIENTOSCONTABLES_GUARDAR_DATOS_REGISTRO_REPROCESO = "ASIENTOSCONTABLES_GUARDAR_DATOS_REGISTRO_REPROCESO";
export const ASIENTOSCONTABLES_CARGAR_DATOS_ASIENTO_CONTABLE = "ASIENTOSCONTABLES_CARGAR_DATOS_ASIENTO_CONTABLE";
export const ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON = "ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON";
export const ASIENTOSCONTABLES_FILTRAR_CUENTAS = "ASIENTOSCONTABLES_FILTRAR_CUENTAS";
export const ASIENTOSCONTABLES_INPUT_ACTIVO = "ASIENTOSCONTABLES_INPUT_ACTIVO";
export const ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL = "ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL";
export const ASIENTOSCONTABLES_MODIFICAR_ESTADO_ASIENTO = "ASIENTOSCONTABLES_MODIFICAR_ESTADO_ASIENTO";
export const ASIENTOSCONTABLES_CARGAR_RENGLONES_MANUALES = "ASIENTOSCONTABLES_CARGAR_RENGLONES_MANUALES";
export const LIMPIAR_MODAL_ASIENTOS_CONTABLES = "LIMPIAR_MODAL_ASIENTOS_CONTABLES";
export const ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON_NUEVO_ASIENTO ="ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON_NUEVO_ASIENTO";
export const ASIENTOSCONTABLES_ACTUALIZAR_COMENTARIOS = 'ASIENTOSCONTABLES_ACTUALIZAR_COMENTARIOS';
export const ASIENTOSCONTABLES_REINICIAR_CAMPOS_MODAL = "ASIENTOSCONTABLES_REINICIAR_CAMPOS_MODAL";
export const ASIENTOSCONTABLES_SET_ORIGEN_LLAMADO_MODA_BAJA = "ASIENTOSCONTABLES_SET_ORIGEN_LLAMADO_MODA_BAJA";

export const INITIAL_STATE = "INITIAL_STATE";
//Definicion de variables globales
let _dispatch = null;
let _getState = null;
let _executionContext = null;


/* AsientosContables.jsx */
export function obtenerInformacionPantalla(currentScope, executionContext) {
    LogHelper.In(obtenerInformacionPantalla.name, currentScope);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _getState = getState;
        _executionContext = executionContext;

        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _cargarInformacionPantalla(data), null, "GETFUNCTIONS", currentScopeRequest);

        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ASIENTOESTADO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.Execute((data) => _callbackCargarEstadosAsiento(data), null, null, "CONTABILIDAD");
    }
}


function _cargarInformacionPantalla(data) {
    let permisos = [];

    data.CONTABILIDAD.forEach(p => { permisos[p.Codigo_Funcion] = true  });

    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_PERMISOS_USUARIO, permisos });

    let param = {
        "ADMINISTRADORA_ID": null,
    }
    Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_MARCA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product'); 
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ASIENTOESTADO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_SUCURSAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_MONEDA', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ESTADO_ASIENTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS_MANUALES', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

    Engine1Proxy.Execute((data) => _obtencionDatosGrillaPantallaPrincipalAsientosContables(data), null, null, "CONTABILIDAD");
}

function _obtencionDatosGrillaPantallaPrincipalAsientosContables(data) {
    sessionStorage.setItem('PantallaCambios', false);
    let modelosContables = [];
    let marcasActivas = [];
    let datosSucursales = [];
    let datosEstados = [];
    let datosMonedas = [];
    let datosEstadosAsientos = [];
    let cuentasContables = [];
    let centrosCosto = [];
    let modelosManuales = [];
    let usuarioLogin = "";

    modelosContables = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS).Recordset0.Rows;
    marcasActivas = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_MARCA).Recordset0.Rows;
    datosSucursales = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_SUCURSAL).Recordset0.Rows;
    datosEstados = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ASIENTOESTADO).Recordset0.Rows;
    datosMonedas = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_MONEDA).Recordset0.Rows;
    datosEstadosAsientos = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ESTADO_ASIENTO).Recordset0.Rows;
    modelosManuales = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS_MANUALES).Recordset0.Rows;
    cuentasContables = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE).Recordset0.Rows;
    centrosCosto = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO).Recordset0.Rows;
    usuarioLogin = _executionContext.login;

    _dispatch({ type: ASIENTOSCONTABLES_GUARDAR_USUARIO_ACTUAL, usuarioLogin });
    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES, nombreArrayCombo: "datosSucursales", datosCombo: datosSucursales });
    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES, nombreArrayCombo: "datosEstados", datosCombo: datosEstados });
    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_INFORMACION_COMBOS_FILTROS_ADICIONALES, nombreArrayCombo: "datosMonedas", datosCombo: datosMonedas });
    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_DATOS_COMBOS, nombreCombo: "comboEstadosAsientos", datosCombo: datosEstadosAsientos });

    _dispatch({ type: ASIENTOSCONTABLES_POBLAR_GRILLA, modelosContables });
    _dispatch({ type: ASIENTOSCONTABLES_CARGA_INICIAL_FILTRO, marcasActivas });
    _dispatch({ type: ASIENTOSCONTABLES_CARGA_INICIAL_NUEVO_ASIENTO, centrosCosto, cuentasContables, modelosManuales });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}

export function cargarInformacionBtnVer() {
    return (dispatch) => {
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        const params = armarParametrosDataPantallaPrincipal(true, 0);

        Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtencionDatosGrillaPantallaBtnVerAsientosContables(data), null, null, "CONTABILIDAD");
    }
}


function _obtencionDatosGrillaPantallaBtnVerAsientosContables(data) {
    let datosGrilla = []; 

    datosGrilla = JSON.parse(data.AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL).Recordset0.Rows; 
    
    _dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_RESULTADO, resultadoBusqueda: datosGrilla });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}

function _callbackCargarEstadosAsiento(data){

    let estados = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ASIENTOESTADO).Recordset0.Rows;

    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_ESTADOS_ASIENTOS, estados });
}

export function cargarInformacionReproceso(fechaContabilizacion, fechaValor, idModelo, aperturaSucursal, aperturaSocio) {
    return (dispatch) => {
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        let params = {
            'FECHA_CONTABILIZA': fechaContabilizacion ,
            'FECHA_VALOR': fechaValor ,
            'ID_MODELO': idModelo ,
            'APERTURA_SUCURSAL': aperturaSucursal ,
            'APERTURA_SOCIO': aperturaSocio 
        }
            
        Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_REPROCESO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtencionDatosRegistroReproceso(data), null, null, "CONTABILIDAD");
    }
}

function _obtencionDatosRegistroReproceso(data) {
    let datosGrilla = []; 

    datosGrilla = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_REPROCESO).Recordset0.Rows; 
    
    _dispatch({ type: ASIENTOSCONTABLES_GUARDAR_DATOS_REGISTRO_REPROCESO , datos: datosGrilla });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}

function actualizarInformacionGrilla() {
    const params = armarParametrosDataPantallaPrincipal(true, 0);

    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

    Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

    Engine1Proxy.Execute((data) => _obtencionDatosGrillaPantallaBtnVerAsientosContables(data), null, null, "CONTABILIDAD");   
}

/*
    AsientosContables.jsx
*/
export function resetState() {
    LogHelper.In(resetState.name);
    
    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    }
}
        

export function obtenerDatosDetalleAsiento(registro) {

    return (dispatch) => {
        sessionStorage.setItem('PantallaCambios', false);
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        let paramRenglones = {
            "CABECERA_ASIENTO_ID": registro.AsientocabeceraId      
        }

        let paramRenglonesManuales = {
            "MODELO_ID": registro.ModeloCabeceraId      
        }

        Engine1Proxy.AddDataSourcesRequests(paramRenglones, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_REGLONES', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramRenglonesManuales, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ESTADO_ASIENTO', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _callbackObtenerDatosDetalleAsiento(data, registro), null, null, "CONTABILIDAD");
    }
}

function _callbackObtenerDatosDetalleAsiento(data, registro) {
    let datosRenglones = [];
    let datosRenglonesManuales = [];
    let datosCuentasContables = [];
    let datosEstadosAsiento = []; // Acá se van almacenar los estados del asiento que se utlilizan unicamente en el combo de estados del modal
    let datosCentroCosto= [];

    datosRenglones = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_REGLONES).Recordset0.Rows;
    datosRenglonesManuales = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows;
    datosCuentasContables = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CUENTA_CONTABLE).Recordset0.Rows;
    datosEstadosAsiento = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_ESTADO_ASIENTO).Recordset0.Rows;
    datosCentroCosto = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_CENTRO_COSTO).Recordset0.Rows;

    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_DATOS_ASIENTO_CONTABLE, datosRenglones, datosRenglonesManuales, datosCuentasContables, datosEstadosAsiento, datosCentroCosto, registro });

    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });

    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal: "modalDetalleAsiento", mostrarModal: true });
}

export function obtenerDetallesModelo(modeloId) {
    return (dispatch) => {
    let params = {
        "MODELO_ID": modeloId      
    }

    Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

    Engine1Proxy.Execute((data) => _callbackObtenerDetallesModelo(data), null, null, "CONTABILIDAD");

    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });
    }
}

function _callbackObtenerDetallesModelo(data) {
    let detallesModelo = [];
    detallesModelo = JSON.parse(data.AD17P_MODELOSCONTABLES_GET_PANTALLA_ABM).Recordset0.Rows;

    _dispatch({ type: ASIENTOSCONTABLES_CARGAR_DATOS_MODELO, detallesModelo});
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}

export function mostrarOcultarModalAsientosContables(nombreModal, mostrarModal) {
    return (dispatch) => {
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal, mostrarModal });
    }
}

export function mostrarOcultarSpinner(valor) {
    return (dispatch) => {
        
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor });
    }
}

/*
Modales\ModalSeleccionModelos\BuscadorModelosContables.jsx
*/

export function cambiarEstadoAsiento(estadoId, estadoDescripcion, seccionArray) {
    return (dispatch, getState) => {
        sessionStorage.setItem('PantallaCambios', true);
        dispatch({ type: ASIENTOSCONTABLES_MODIFICAR_ESTADO_ASIENTO, estadoId, estadoDescripcion, seccionArray });
    }
}

export function buscarModelosContables(valorInput) {
    LogHelper.In(buscarModelosContables.name, valorInput);

    return (dispatch, getState) => {
        let modelos = getState().asientosContables.modelosContablesActivos;
        let modelosSeleccionados = getState().asientosContables.inputsAsientosContables.modalSeleccionModelos.modelosContablesSeleccionados;
        let inputs = JSON.parse(JSON.stringify(getState().asientosContables.inputsAsientosContables));

        inputs.modalSeleccionModelos.modelosContablesFiltrados = busquedaModelosContables(modelos, modelosSeleccionados, valorInput)
        inputs.modalSeleccionModelos.inputBuscadorModelos = valorInput;

        dispatch({ type: ASIENTOSCONTABLES_FILTRAR_MODELOS, inputs });
    }
}

export function buscarCuentasContables(renglonId, seccionArray, valorInput) {
    return (dispatch, getState) => {
 
        let cuentasContables = getState().asientosContables[seccionArray].cuentasContables
        let renglonesAgregadosManualmente = getState().asientosContables[seccionArray].renglonesAgregadosManualmente
        let cuentasContablesFiltradas = cuentasContables.filter(cuenta =>  cuenta.Descripcion.toLowerCase().includes(valorInput.toLowerCase()) || cuenta.Codigo.toString().includes(valorInput.toString()));
   
        let renglonesModificados = renglonesAgregadosManualmente.map(renglon =>
            renglon.renglonId === renglonId ? { ...renglon, cuentasContablesFiltradas } : renglon );
 
        dispatch({ type: ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL, renglonesModificados, seccionArray, nombreArray: "renglonesAgregadosManualmente" });
    }
}

export function cargarRenglonesManualesFiltradosDelModelo(renglonesManualesFiltrados, renglonesAsientoIdentificados, nombreArray) { 
    return (dispatch, getState) => {
        dispatch({ type: ASIENTOSCONTABLES_CARGAR_RENGLONES_MANUALES, renglonesManualesFiltrados, renglonesAsientoIdentificados, nombreArray });
    };
}

export function agregarRenglonManual(nuevoId, seccionArray, nombreArray) { 
    return (dispatch, getState) => {
        sessionStorage.setItem('PantallaCambios', true);
        let nuevoRenglonTemplate = getState().asientosContables[seccionArray].nuevoRenglonTemplate;
        let renglonesAgregadosManualmente = getState().asientosContables[seccionArray].renglonesAgregadosManualmente;
        let cuentasContablesState = getState().asientosContables[seccionArray].cuentasContables;

        let nuevosRenglonesAgregadosManualmente = [
            ...renglonesAgregadosManualmente,
            {...nuevoRenglonTemplate, renglonId: nuevoId, cuentasContablesFiltradas: cuentasContablesState}
        ];

        dispatch({ 
            type: ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL, 
            renglonesModificados: nuevosRenglonesAgregadosManualmente, seccionArray, nombreArray
        });
    };
}

export function modificarRenglonManual(renglonId, renglonManualModificado, seccionArray, nombreArray) { 
    return (dispatch, getState) => {
        sessionStorage.setItem('PantallaCambios', true);
        let renglonesState = getState().asientosContables[seccionArray][nombreArray];

        let nuevosRenglonesAgregadosManualmente;
        if (renglonManualModificado === null) { // este caso es para la eliminación del renglon
            nuevosRenglonesAgregadosManualmente = renglonesState.map(renglon => 
                renglon.renglonId === renglonId ? { ...renglon, EliminaRenglon: true } : renglon
            );
        } else {
            nuevosRenglonesAgregadosManualmente = renglonesState.map(renglon => 
                renglon.renglonId === renglonId ? { ...renglon, ...renglonManualModificado } : renglon
            );
        }

        dispatch({ 
            type: ASIENTOSCONTABLES_GESTIONAR_RENGLON_MANUAL, 
            renglonesModificados: nuevosRenglonesAgregadosManualmente, 
            seccionArray,
            nombreArray 
        });
    };
}

export function guardarActualizarAsientoContable(seccionArray) {
    return (dispatch, getState) => {
        
        let renglonesAsientoIdentificados = [];
        let renglonesEliminados = [];
        let datosAsiento = {};
        let usuario = _executionContext.login;
        let renglonesAgregadosManualmente = getState().asientosContables[seccionArray].renglonesAgregadosManualmente;
        let renglonesDelModeloFiltrados = getState().asientosContables[seccionArray].renglonesManualesFiltrados;
   
        if(seccionArray == "propsModalNuevoAsiento"){
            let modeloSeleccionado = getState().asientosContables.detallesModeloElegido[0]
            let [dia, mes, año] = getState().asientosContables[seccionArray].selectorFechaNuevoAsiento.split("/").map(Number);
   
            datosAsiento.FechaValorContable = new Date(año, mes - 1, dia);
            datosAsiento.ModeloCabeceraId = modeloSeleccionado.ModeloContableCabeceraId;
            datosAsiento.TipoAsiento = 2; // Al cargar un asiento manual desde el "ModalNuevoAsiento" se asume que es un Asiento de tipo MANUAL (2)
            datosAsiento.EstadoId = 1;
            datosAsiento.ModeloCabeceraDescripcion = modeloSeleccionado.DescripcionModelo;
            datosAsiento.Comentarios = getState().asientosContables.propsModalNuevoAsiento.comentarios;
            datosAsiento.MonedaId = modeloSeleccionado.ModeloMonedaId;
            datosAsiento.ModeloCabeceraDescripcion = modeloSeleccionado.DescripcionModelo;
            datosAsiento.AdministradoraId = modeloSeleccionado.AdministradoraId;
            datosAsiento.SucursalId = modeloSeleccionado.SucursalId;
            datosAsiento.IndicadorInterfazId = modeloSeleccionado.IndicadorInterfazId;
            datosAsiento.RequiereReverso = modeloSeleccionado.RequiereReverso;
            datosAsiento.DiasDiferimiento = modeloSeleccionado.DiasDiferimiento;
            datosAsiento.FechaContabilizacion = new Date();

        } 

        // Si se llama desde modal de detalle asiento se asume que puede tener renglones del asiento, caso contrario no existen renglones por ende se deja el valor por default (null)
        if(seccionArray == "modalAsientosContables"){
            renglonesAsientoIdentificados = getState().asientosContables[seccionArray].renglonesAsientoIdentificados;
            renglonesEliminados = renglonesAsientoIdentificados.filter(renglon => renglon.EliminaRenglon == true);
            datosAsiento = getState().asientosContables[seccionArray].registroDetalle;

            
            // la rule recibe el Id del estado mediante la propiedad EstadoId, se evalua si se seleccionó algun valor en el combo de estado para enviar ese valor a la rule
            datosAsiento.EstadoId =  !datosAsiento.EstadoIdCombo ? datosAsiento.EstadoId : datosAsiento.EstadoIdCombo
            
        } 

        renglonesDelModeloFiltrados = renglonesDelModeloFiltrados.filter(renglon => Boolean(renglon.ImporteAsiento));
        
        let renglonesValidos = [...renglonesAsientoIdentificados, ...renglonesAgregadosManualmente, ...renglonesDelModeloFiltrados]
            .filter(renglon => !renglonesEliminados.includes(renglon));

        // Calculamos los totales utilizando la función
        let TotalImputadoDebito = calcularTotal(renglonesValidos, "PESO", 1);
        let TotalImputadoCredito = calcularTotal(renglonesValidos, "PESO", 2);
        let TotalImputadoDebitoDolar = calcularTotal(renglonesValidos, "DOLAR", 1);
        let TotalImputadoCreditoDolar = calcularTotal(renglonesValidos, "DOLAR", 2);
        
        datosAsiento.TotalImputadoDebito = parseFloat(TotalImputadoDebito.toFixed(2));
        datosAsiento.TotalImputadoCredito = parseFloat(TotalImputadoCredito.toFixed(2));
        datosAsiento.TotalImputadoDebitoDolar = parseFloat(TotalImputadoDebitoDolar.toFixed(2));
        datosAsiento.TotalImputadoCreditoDolar = parseFloat(TotalImputadoCreditoDolar.toFixed(2));
    
        if(seccionArray == "modalAsientosContables"){
             _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal: "modalDetalleAsiento", mostrarModal: false });
        }

        let param = {
            USUARIO: usuario,
            RENGLONESAGREGADOSMANUALMENTE: renglonesAgregadosManualmente,
            RENGLONESDELMODELOFILTRADOS: renglonesDelModeloFiltrados,
            RENGLONESAELIMINAR: renglonesEliminados,
            DATOSASIENTO: datosAsiento,
        };

        Engine1Proxy.AddRuleRequests(param, 'ACTUALIZARGUARDARASIENTOCONTABLE', 'Tarjetas', 'CONTABILIDAD');

        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        Engine1Proxy.Execute((data) => _callbackGuardarActualizarAsientoContable(data), null, null, "CONTABILIDAD");

        sessionStorage.setItem('PantallaCambios', false);
        _dispatch({ type: LIMPIAR_MODAL_ASIENTOS_CONTABLES});
    };
}


function _callbackGuardarActualizarAsientoContable(result) {

    let resultado = JSON.parse(result.ACTUALIZARGUARDARASIENTOCONTABLE);

    if(!resultado.EsError) {

        const params = armarParametrosDataPantallaPrincipal(true, 0);

        Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');

        Engine1Proxy.Execute((data) => _obtencionDatosGrillaPantallaBtnVerAsientosContables(data), null, null, "CONTABILIDAD");
    }
}

export function limpiarModalAsientosContables() {
    sessionStorage.setItem('PantallaCambios', false);
    return (dispatch) => { dispatch({ type: LIMPIAR_MODAL_ASIENTOS_CONTABLES}); };
}

/*
    Common\ListaModelosSeleccionados.jsx
    Modales\ModalSeleccionModelos\OpcionBuscadorModelos.jsx
*/
export function guardarQuitarModeloSeleccionado(modelo, adicionarModelo) {
    LogHelper.In(guardarQuitarModeloSeleccionado.name, modelo, adicionarModelo);

    return (dispatch, getState) => {
        let modelos = JSON.parse(JSON.stringify(getState().asientosContables.modelosContablesActivos));
        let inputs = JSON.parse(JSON.stringify(getState().asientosContables.inputsAsientosContables));
        let checks = JSON.parse(JSON.stringify(getState().asientosContables.checksAsientosContables));
        let modeloSeleccionado = modelo == "Todos" ? modelo : modelos.filter(m => {return m.Id == modelo})[0];
        let mostrarVerMas = JSON.parse(JSON.stringify(getState().asientosContables.mostrarVerMas));

        if (adicionarModelo) {
            inputs.modalSeleccionModelos.modelosContablesSeleccionados.push(modeloSeleccionado);
            inputs.modalSeleccionModelos.modelosContablesFiltrados = inputs.modalSeleccionModelos.modelosContablesFiltrados.filter(m => {return m.Id != modelo})

            //Si la longitud del array de modelos seleccionados es igual al de los modelos activos, quiere decir que se seleccionaron todos los modelos, entonces tildo el check de todos los modelos seleccionados
            if(modelos.length == inputs.modalSeleccionModelos.modelosContablesSeleccionados.length) {
                inputs.modalSeleccionModelos.inputBuscadorModelos = "";
                checks.modalSeleccionModelos.checkTodosModelos = true;
            }
        } else {
            if(modelo == "Todos") {
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
                inputs.modalSeleccionModelos.modelosContablesFiltrados = modelos;
            } else {
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = inputs.modalSeleccionModelos.modelosContablesSeleccionados.filter(m => {return m.Id != modelo})
                inputs.modalSeleccionModelos.modelosContablesFiltrados.push(modeloSeleccionado);

                mostrarVerMas = !mostrarVerMas ? inputs.modalSeleccionModelos.modelosContablesSeleccionados.length == 8 : mostrarVerMas;
            }

            checks.modalSeleccionModelos.checkTodosModelos = false;
        }

        inputs.modalSeleccionModelos.modelosContablesSeleccionados = inputs.modalSeleccionModelos.modelosContablesSeleccionados.sort((a,b) => a.Id - b.Id);
        inputs.modalSeleccionModelos.modelosContablesFiltrados = inputs.modalSeleccionModelos.modelosContablesFiltrados.sort((a,b) => a.Id - b.Id);


        dispatch({ type: ASIENTOSCONTABLES_GUARDAR_QUITAR_MODELO_SELECCIONADO, inputs, checks, mostrarVerMas });
    }
}


/*
    Common\ListaModelosSeleccionados.jsx
*/
export function ocultarBotonVerMas() {
    LogHelper.In(ocultarBotonVerMas.name);

    return (dispatch) => {
        dispatch({ type: ASIENTOSCONTABLES_OCULTAR_BOTON_VERMAS });
    }
}


/*
    SeccionFiltros\SeccionFiltros.jsx
*/
export function seleccionarOpcionCombo(nombreCombo, valorCombo, mostrarConfirmacion) {
    LogHelper.In(ocultarBotonVerMas.name);

    return (dispatch, getState) => {
        if(mostrarConfirmacion) {
            _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal: "modalConfirmarEliminacionModelos", mostrarModal: true });
            _dispatch({ type: ASIENTOSCONTABLES_GUARDAR_VALOR_COMBO_TEMPORAL, valorCombo });
        } else {
            let inputs = JSON.parse(JSON.stringify(getState().asientosContables.inputsAsientosContables));
            let combos = JSON.parse(JSON.stringify(getState().asientosContables.combosAsientosContables));
            let checks = JSON.parse(JSON.stringify(getState().asientosContables.checksAsientosContables));
            //Cmabiar por obtencion de datos 
            let resultadoBusqueda = JSON.parse(JSON.stringify(getState().asientosContables.arrayResultadoBusquedaAsientos));

            if(nombreCombo == "comboMarca") {

                //Al cambiar de valor del combo de Marcas, se limpian los modelos seleccionados, con lo cual destildo el check de "seleccionar todos los modelos"
                checks.modalSeleccionModelos.checkTodosModelos = false;
            }

            if (nombreCombo == "comboAccionMasiva") {
                resultadoBusqueda = resultadoBusqueda.map(reg => {
                    let estaDesbalanceado = reg.TotalImputadoDebito != reg.TotalImputadoCredito;
                    let mismoUsuario = reg.UsuarioCreacion == _executionContext.login;
                    switch (valorCombo) {
                        case "1": // Confirmar
                            reg.EstaHabilitado = !(estaDesbalanceado || reg.EstadoId !== 1 || (reg.Manual === "Sí" && mismoUsuario));
                            reg.EstaTildado = reg.EstaHabilitado && checks.checkTodosAsientosContables;
                            break;
                        case "2": // Desconfirmar
                            reg.EstaHabilitado = !(reg.EstadoId !== 2);
                            reg.EstaTildado = reg.EstaHabilitado && checks.checkTodosAsientosContables;
                            break;
                        case "3": // Dar de Baja
                            reg.EstaHabilitado = !(reg.EstadoId !== 1 && reg.EstadoId !== 2);
                            reg.EstaTildado = reg.EstaHabilitado && checks.checkTodosAsientosContables;
                            break;
                        case "0": // Ninguna
                            reg.EstaHabilitado = false;
                            reg.EstaTildado = false;
                            break;
                        default:
                            break;
                    }
                    return reg;
                });
            }

            combos[nombreCombo] = valorCombo;

            _dispatch({ type: ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO, combos, inputs, mostrarVerMas: true, checks});
            _dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_RESULTADO, resultadoBusqueda });

            if(nombreCombo == "comboMarca") {
                _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

                let param = {
                    "ADMINISTRADORA_ID": valorCombo == 0 ? null : valorCombo,
                }           
            
                Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
                Engine1Proxy.Execute((data) => _callbackActualizarModelosMarca(data, inputs), null, null, "CONTABILIDAD");
            }
        }
    }
}

function _callbackActualizarModelosMarca(data, inputs) {
    let modelosContables = [];

    modelosContables = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS).Recordset0.Rows;

    inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
    inputs.modalSeleccionModelos.modelosContablesFiltrados = modelosContables;
    inputs.modalSeleccionModelos.inputBuscadorModelos = "";


    _dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_MODELOS_MARCA, inputs, modelosContables });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}


/*
    Modales\ModalConfirmarEliminacionModelos\ModalConfirmarEliminacionModelos.jsx
*/
export function limpiarModelosSeleccionados(valorComboMarcaTemporal) {
    LogHelper.In(limpiarModelosSeleccionados.name, valorComboMarcaTemporal);

    return (dispatch, getState) => {
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal: "modalConfirmarEliminacionModelos", mostrarModal: false });
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        let param = {
            "ADMINISTRADORA_ID": valorComboMarcaTemporal == "0" ? null : valorComboMarcaTemporal,
        }           
    
        Engine1Proxy.AddDataSourcesRequests(param, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
        Engine1Proxy.Execute((data) => _callbackLimpiarModelos(data, valorComboMarcaTemporal), null, null, "CONTABILIDAD");        
    }
}

function _callbackLimpiarModelos(data, valorComboMarcaTemporal) {
    

    let inputs = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables));
    let combos = JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables));
    let checks = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables));

    let modelosContables = [];

    modelosContables = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MODELOS).Recordset0.Rows;

    inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
    inputs.modalSeleccionModelos.modelosContablesFiltrados = modelosContables;

    combos.comboMarca = valorComboMarcaTemporal;
    
    //Al cambiar de valor del combo de Marcas, se limpian los modelos seleccionados, con lo cual destildo el check de "seleccionar todos los modelos"
    checks.modalSeleccionModelos.checkTodosModelos = false;

    _dispatch({ type: ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO, combos, inputs, mostrarVerMas: true, checks });        
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
}

/*
    SeccionFiltros\SeccionFiltros.jsx
*/
export function desplegarFiltros(estaDesplegado) {
    LogHelper.In(desplegarFiltros.name, estaDesplegado);

    return (dispatch) => {
        dispatch({ type: ASIENTOSCONTABLES_DESPLEGAR_FILTROS, estaDesplegado });
    };
}

/*
    Common\SelectorFecha.jsx
*/
export function validarInputFecha(nombreInput, fechaInput) {
    return (dispatch) => {
        let inputs = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables));
        let errorValidacion = JSON.parse(JSON.stringify(_getState().asientosContables.errorValidacion));
        let fechaDesde = (nombreInput.includes('Desde') && fechaInput) || inputs[nombreInput.replace("Hasta", "Desde")];
        let fechaHasta = (nombreInput.includes('Hasta') && fechaInput) || inputs[nombreInput.replace("Desde", "Hasta")];
        let nombreInputContenedor = nombreInput.replace("Hasta", "").replace("Desde", "") + "Contenedor";

        const resultadoValidacionFecha = validarFecha(fechaInput, fechaDesde, fechaHasta);

        //Asignación de mensajes y flags de error al objeto de errorValidacion
        errorValidacion[nombreInput] = resultadoValidacionFecha.esError;
        errorValidacion[nombreInputContenedor] = resultadoValidacionFecha.mensaje;
        
        //Reinicio los valores a false de ambos inputs (desde y hasta) en caso de que las validaciones hayan sido correctas (no se generó ningún mensaje de error)
        if(resultadoValidacionFecha.mensaje == "") {
            errorValidacion[nombreInput.replace("Hasta", "Desde")] = false;
            errorValidacion[nombreInput.replace("Desde", "Hasta")] = false;
        }

        inputs[nombreInput] = fechaInput;

        _dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_MENSAJE_ERROR, errorValidacion });  
        _dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_FECHA, inputs });
    };
}

export function validarSelectorFecha(nombreInput, fechaInput) {

    return (dispatch) => {
        // let fechaNuevoAsiento = JSON.parse(JSON.stringify(_getState().asientosContables.propsModalNuevoAsiento.selectorFechaNuevoAsiento));

        let fechaInputSplit = fechaInput.split('/');
        let fechaInputFormateada = fechaInputSplit[2] + "-" + fechaInputSplit[1] + "-" + fechaInputSplit[0];

        _dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_FECHA_SELECTOR, fechaNuevoAsiento: fechaInputFormateada });

    }
    
}
  

/*
    SeccionFiltros\SeccionFiltros.jsx
    Modales\ModalSeleccionModelos\BuscadorModelosContables.jsx
*/
export function cambiarCheckAsientosContables(nombreCheck, valorCheck) {
    LogHelper.In(cambiarCheckAsientosContables.name, nombreCheck, valorCheck);

    return (dispatch, getState) => {
        let checks = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables));
        let inputs = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables));
        let modelos = JSON.parse(JSON.stringify(_getState().asientosContables.modelosContablesActivos));
        let marcaSeleccionada = _getState().asientosContables.combosAsientosContables.comboMarca;
        let resultadoBusqueda = JSON.parse(JSON.stringify(_getState().asientosContables.arrayResultadoBusquedaAsientos));

        checks[nombreCheck] = valorCheck;              
              
        if(nombreCheck == "checkTodosModelos") {
            checks.modalSeleccionModelos[nombreCheck] = valorCheck;

            if(valorCheck) {
                inputs.modalSeleccionModelos.modelosContablesFiltrados = [];
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = marcaSeleccionada != "0" ? modelos.filter(modelo => modelo.AdministradoraId == marcaSeleccionada) : modelos;
                inputs.modalSeleccionModelos.inputBuscadorModelos = "";
            } else {
                inputs.modalSeleccionModelos.modelosContablesFiltrados = marcaSeleccionada != "0" ? modelos.filter(modelo => modelo.AdministradoraId == marcaSeleccionada) : modelos;
                inputs.modalSeleccionModelos.modelosContablesSeleccionados = [];
                inputs.modalSeleccionModelos.inputBuscadorModelos = "";
            }
        }

        if (nombreCheck == "checkTodosAsientosContables") {
              valorCheck ?
              resultadoBusqueda = resultadoBusqueda.map(reg => ({
                ...reg,
                EstaTildado: reg.EstaHabilitado
              })):
              resultadoBusqueda = resultadoBusqueda.map(reg => ({
                ...reg,
                EstaTildado: false
              }))
        }
        dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_RESULTADO, resultadoBusqueda });
        dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_CHECK, checks, inputs });
    }
}

export function cambiarCheckRegistroResultadoBusqueda(valorCheck, registro) {
    LogHelper.In(cambiarCheckRegistroResultadoBusqueda.name, valorCheck, registro);

    return (dispatch, getState) => {
        //Cambiar por obtencion de datos
        let resultadoBusqueda = getState().asientosContables.arrayResultadoBusquedaAsientos;

        const regIndex = resultadoBusqueda.indexOf(registro);

        let updatedResultadoBusqueda = [...resultadoBusqueda];
        
        updatedResultadoBusqueda[regIndex] = {
            ...registro,
            EstaTildado: valorCheck
        };
  
        dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_RESULTADO, resultadoBusqueda: updatedResultadoBusqueda });
    }
}

/*
    SeccionGrilla\RegistroAsientoContable.jsx
*/

export function desplegarDatosAdicionales(idAsiento) {
    LogHelper.In(desplegarDatosAdicionales.name, idAsiento);
    
     return (dispatch, getState) => {    
        let registroDesplegado = getState().asientosContables.registroDesplegado;

        idAsiento = idAsiento == registroDesplegado ? null : idAsiento;

        dispatch({ type: ASIENTOSCONTABLES_DESPLEGAR_DATOS_ADICIONALES, idAsiento });    
     };
}

/*
    Modales\ModalDetalleAsiento\ModalDetalleAsiento.jsx
*/
export function desplegarDatosDetalleAsiento(nombreOpcionSeleccionada) {
    LogHelper.In(desplegarDatosDetalleAsiento.name, nombreOpcionSeleccionada);

    return (dispatch, getState) => {
        let datosDesplegados = getState().asientosContables.modalAsientosContables.detalleAsientoDatosDesplegados;

        let valor = datosDesplegados == nombreOpcionSeleccionada ? null : nombreOpcionSeleccionada;

        dispatch({ type: ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_ASIENTO, valor });
    };
}


export function desplegarDatosDetalleRenglon(nroRenglon, seccionArray) {
    return (dispatch, getState) => {
        let datosDesplegados = getState().asientosContables[seccionArray].detalleRenglonDatosDesplegados;
        let nuevoEstado = null;

        if (!datosDesplegados || datosDesplegados !== nroRenglon) {
            nuevoEstado = nroRenglon; 
        }
        dispatch({ type: ASIENTOSCONTABLES_DESPLEGAR_DATOS_DETALLE_RENGLON, seccionArray, valor: nuevoEstado });
    };
}

export const reiniciarCamposModalNuevoAsiento = () => {
    return (dispatch) => {
        dispatch({ type: ASIENTOSCONTABLES_REINICIAR_CAMPOS_MODAL });
    };
};

export function setearOrigenLlamadoModalConfirmacionBaja(origen) {
    return (dispatch) => {
        dispatch({ type: ASIENTOSCONTABLES_SET_ORIGEN_LLAMADO_MODA_BAJA, origen });
    };
};

export function armarDatosExportacionExcel(registro, arrayRenglonesContables, registroDatosReproceso) {
    return function(dispatch, getState) {

        // Crear un objeto 'detalleAsiento' a partir de 'registro'
        let detalleAsiento = {
            AsientoCabeceraId: registro.AsientocabeceraId,
            ModeloCabeceraId: registro.ModeloCabeceraId,
            ModeloCabeceraDescripcion: registro.ModeloCabeceraDescripcion,
            MonedaDescripcion: registro.MonedaDescripcion,
            IndicadorDescripcion: registro.IndicadorDescripcion,
            SucursalDescripcion: registro.SucursalDescripcion,
            AperturaCuentaTarjeta: registro.AperturaCuentaTarjeta,
            FechaValorContable: registro.FechaValorContable,
            FechaContabilizacion: registro.FechaContabilizacion,
            Manual: registro.Manual,
            ConfirmacionAutomatica: registro.ConfirmacionAutomatica,
            EstadoDescripcion: registro.EstadoDescripcion,
            TipoConsolidacion: registro.TipoConsolidacion,
            FechaCreacion: registro.FechaCreacion,
            UsuarioCreacion: registro.UsuarioCreacion,
            TerminalCreacion: registro.TerminalCreacion,
            FechaModificacion: registro.FechaModificacion,
            UsuarioModificacion: registro.UsuarioModificacion,
            TerminalModificacion: registro.TerminalModificacion,
            UsuarioConfirmacion: registro.UsuarioConfirmacion,
            FechaConfirmacion: registro.FechaConfirmacion,
            TerminalConfirmacion: registro.TerminalConfirmacion,
            UsuarioEnvio: registro.UsuarioEnvio,
            FechaEnvio: registro.FechaEnvio,
            TerminalEnvio: registro.TerminalEnvio,
        };
            
        let renglones = arrayRenglonesContables;

        let datosReproceso = registroDatosReproceso;
        let comentarios = [{Comentarios: registro.Comentarios}];

        let datosExcelFinal = {
            detalleAsiento: detalleAsiento,
            renglones: renglones,
            datosReproceso: datosReproceso,
            comentarios: comentarios
        };
        

        _dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_DATOSEXCEL, datosExcelFinal  });

    };
}

export function descargarExcel(data = null, incluirDetalles = false) {
    return (dispatch) => {
        // En caso que no venga data por parametro, hago la obtencion de datos de la grilla de asientos
        if (!data) {
            let params = armarParametrosDataPantallaPrincipal(true, incluirDetalles);
            _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });
            _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL, nombreModal: "modalConfirmarDetalleAsiento", mostrarModal: false });

            Engine1Proxy.AddDataSourcesRequests(params, 'AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
            Engine1Proxy.Execute((data) => procesarDatosYDescargar(data), null, null, "CONTABILIDAD");
        } else {
            procesarDatosYDescargar(data);
        }
    };
}

function procesarDatosYDescargar(data) {
    // En caso que los datos vengan directamente por callback despues de hacer la obtencion de datos, asigno el valor del recordset parseado a "data"
    if(data.AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL){
        data = JSON.parse(data.AD17P_ASIENTOSCONTABLES_GET_PANTALLA_PRINCIPAL).Recordset0.Rows;
    }

    let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB')).replaceAll("-", "");
    let nombreArchivo = fechaActual + "_dataAsientosContables.xlsx";
    let excelBody = [];
    let headersDinamicos = [];
    
    if (data.detalleAsiento) {
        let nombreHoja1 = "Datos generales";
        let nombreHoja2 = "Renglones contables";
        let nombreHoja3 = "Comentarios";
        let nombreHoja4 = "Datos reproceso";
        let nombreReporte = "Datos del Asiento N°" + data.detalleAsiento.AsientoCabeceraId;


        excelBody = [
            {
                SheetName: nombreHoja1,
                Content: {
                    DetalleAsientoContableContent: [data.detalleAsiento]
                }
            },
            {
                SheetName: nombreHoja2,
                Content: {
                    DetalleAsientoContableContent: data.renglones
                }
            }
        ];

        if (data.comentarios && data.comentarios.length > 0) {
            excelBody.push({
                SheetName: nombreHoja3,
                Content: {
                    DetalleAsientoContableContent: data.comentarios
                }
            });
        }

        if (data.datosReproceso && data.datosReproceso.length > 0) {
            excelBody.push({
                SheetName: nombreHoja4,
                Content: {
                    DetalleAsientoContableContent: data.datosReproceso
                }
            });
        }

        let params = {
            FileConfigName: "DetalleAsientoContable_Excel",
            ExcelBody: excelBody,
            FileName: nombreArchivo,
            ReportTitle: nombreReporte
        };

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError);

 } else {
        let cabeceras = [];
        let renglones = [];
        let datosCombinados = [];
        
        data.forEach(registro => {
            if (registro.DatosRenglones !== false) {
                const separatorIndex = Object.keys(registro).indexOf('DatosRenglones');

                const cabecera = {};
                const renglonesRegistro = {};

                for (const key in registro) {
                    if (Object.hasOwnProperty.call(registro, key)) {
                        if (Object.keys(registro).indexOf(key) < separatorIndex) {
                            cabecera[key] = registro[key];
                        } else {
                            renglonesRegistro[key] = registro[key];
                        }
                    }
                }

                cabeceras.push(cabecera);
                renglones.push(renglonesRegistro);
            } else {
                cabeceras.push({ ...registro });
            }
        });

        if (renglones.length > 0) {
            const primerRenglon = renglones[0];
            const entries = Object.entries(primerRenglon);

            const nuevosHeaders = entries.map(([key, value]) => ({
                Name: key,
                Description: key,
                DataType: typeof value,
                Totalize: false,
                Sheet: "Asientos Contables",
                UsaColorSecundario: true
            }));

            headersDinamicos.push(...nuevosHeaders);

            datosCombinados = cabeceras.map((cabecera, index) => ({
                ...cabecera,
                DynamicData: renglones[index]
            }));
        }

        let params = {
            FileConfigName: "AsientosContables_Excel",
            ExcelBody: [
                {
                    SheetName: "Asientos Contables",
                    Content: {
                        AsientosContablesContent: renglones.length > 0 ? datosCombinados : cabeceras
                    }
                }
            ],
            FileName: nombreArchivo,
            ReportTitle: "Asientos Contables",
            HeadersDinamicos: headersDinamicos
        };

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError);
    }
}

function _callbackFileDownload(response) {
    try {
        if (response) {
            const nombreArchivo = JSON.parse(response.config.data)?.FileName;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', nombreArchivo);
            document.body.appendChild(link);
            link.click();

            _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
        }
    } catch (error) {
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + error, redireccionarPantallaPrincipal: false });
    }
}

function _callbackMostrarMensajeError(response) {
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_MODAL_MENSAJE_RESULTADO, mensaje: "Ocurrió un error al intentar descargar el archivo. Información: " + response, redireccionarPantallaPrincipal: false });
}



export function descargaTipoMovimiento(parametrosDescargaExcel){
    return (dispatch, getState) => {

    let param_UP_GET_CRITERIO_CONTABLE = {
        "MODELO_CABECERA_ID": parametrosDescargaExcel.ModeloCabeceraId,
        "MODELO_DETALLE_ID":parametrosDescargaExcel.ModeloDetalleId,
        "ASIENTO_CABECERA_ID":parametrosDescargaExcel.AsientoCabeceraId
    }

    let param_AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MOVIMIENTOS = {
        "ASIENTO_CABECERA_ID":parametrosDescargaExcel.AsientoCabeceraId,
        "MODELO_DETALLE_ID":parametrosDescargaExcel.ModeloDetalleId,
        "TIPO_APERTURA":parametrosDescargaExcel.TipoApertura,
        "VALOR_APERTURA":parametrosDescargaExcel.ValorApertura
        
    }

    let datosGenerales = {
        Modelo: parametrosDescargaExcel.ModeloCabeceraId,
        ModeloDescripcion: parametrosDescargaExcel.ModeloDescripcion,
        Moneda: parametrosDescargaExcel.MonedaDescripcion,
        NroRenglon: parametrosDescargaExcel.NroRenglon,
        Sucursal: parametrosDescargaExcel.SucursalDescripcion,
    }

    Engine1Proxy.AddDataSourcesRequests(param_UP_GET_CRITERIO_CONTABLE, 'UP_GET_CRITERIO_CONTABLE', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(param_AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MOVIMIENTOS, 'AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MOVIMIENTOS', 'Get', 'Tarjetas', 'CONTABILIDAD', 1, 'Product');
    Engine1Proxy.Execute((data) => _callbackArmarDatosExcelTipoMovimiento(data , datosGenerales), null, null, "CONTABILIDAD");
    };
}

function _callbackArmarDatosExcelTipoMovimiento(data, datosGenerales) {
    let criterosContables = JSON.parse(data.UP_GET_CRITERIO_CONTABLE).Recordset0.Rows;
    let datosMovimientos = JSON.parse(data.AD17P_TABLERO_ASIENTOS_CONTABLES_GET_MOVIMIENTOS).Recordset0.Rows;

    let excelBody = [];
    let headersDinamicos = [];
    let TipoMovimientoContent = [];

    if (datosMovimientos && datosMovimientos.length > 0) {
        headersDinamicos = Object.entries(datosMovimientos[0]).map(([key, value]) => ({
            Name: key,
            Description: key,
            DataType: typeof value,
            Totalize: false,
            Sheet: 'Movimientos'
        }));

        TipoMovimientoContent = [{ DynamicData: datosMovimientos[0] }];

        let nombreHoja2 = "Movimientos";
        excelBody.push({
            SheetName: nombreHoja2,
            Content: {
                TipoMovimientoContent
            }
        });
    }

    if (criterosContables && criterosContables.length > 0) {
        let nombreHoja1 = "Criterios Contables";
        excelBody.push({
            SheetName: nombreHoja1,
            Content: {
                TipoMovimientoContent: criterosContables
            }
        });
    }

    if (excelBody.length > 0) {
        let fechaActual = formatearFecha(new Date().toLocaleDateString('en-GB'));
        let nombreArchivo = fechaActual + "_DataAsientosContables.xlsx";
        let nombreReporte = "Reporte de trazabilidad - Modelo: " + datosGenerales.Modelo + " - " + datosGenerales.ModeloDescripcion + " Reglón: " + datosGenerales.NroRenglon + " Sucursal: " + datosGenerales.Sucursal + " Moneda: " + datosGenerales.Moneda;

        let params = {
            FileConfigName: "DetalleTipoMovimiento_Excel",
            ExcelBody: excelBody,
            FileName: nombreArchivo,
            ReportTitle: nombreReporte,
            HeadersDinamicos: headersDinamicos
        };

        AxiosManager.AxiosRequest('post', GetApiUrlsHelper.GetAxiosUrl('ExcelFile'), null, params, 'arraybuffer', _callbackFileDownload, _callbackMostrarMensajeError);
    }
}



export function validarAplicarAccionMasiva() {
    LogHelper.In(validarAplicarAccionMasiva.name);

    return (dispatch, getState) => {  
        const resultadoBusqueda = JSON.parse(JSON.stringify(getState().asientosContables.arrayResultadoBusquedaAsientos));
        const resultadoFiltrado = resultadoBusqueda.filter(objeto => objeto.EstaTildado && objeto.EstaHabilitado);
        const asientosCabeceraIds = resultadoFiltrado.map(objeto => { return { AsientoId: objeto.AsientocabeceraId };});
        const comboAccionMasiva = JSON.parse(JSON.stringify(getState().asientosContables.combosAsientosContables.comboAccionMasiva));
        const estadoId = comboAccionMasiva == 1 ? 2 : comboAccionMasiva == 2 ? 1 : 3;
        const usuario = _executionContext.login;

        let param = {
            ESTADO_ID: estadoId,
            ASIENTO_CABECERA_IDS: asientosCabeceraIds,
            USUARIO: usuario
        };

        _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: true });

        Engine1Proxy.AddRuleRequests(param, 'ABMASIENTOSCONTABLES', 'Tarjetas', 'CONTABILIDAD');

        Engine1Proxy.Execute((data) => _callbackAccionMasiva(data), null, null, "CONTABILIDAD");
    };
}

function _callbackAccionMasiva(result) {
    LogHelper.In(_callbackAccionMasiva.name, result);
    let resultado = JSON.parse(result.ABMASIENTOSCONTABLES);

    let checks = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables));
	let inputs = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables));
    let combos = JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables));

    checks["checkTodosAsientosContables"] = false;     
    combos["comboAccionMasiva"] = 0;
    
    _dispatch({ type: ASIENTOSCONTABLES_SELECCIONAR_VALOR_COMBO, combos, inputs, mostrarVerMas: false, checks});
    _dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_CHECK, checks, inputs });
    _dispatch({ type: ASIENTOSCONTABLES_MOSTRAR_SPINNER, valor: false });


    if(!resultado.EsError) {
        actualizarInformacionGrilla();
    }
}

export function cambiarValorInput(seccionInput, nombreInput, valorInput) {
    LogHelper.In(cambiarValorInput.name, nombreInput, valorInput);

    return (dispatch) => {
        _dispatch({ type: ASIENTOSCONTABLES_CAMBIAR_VALOR_INPUT, seccionInput, nombreInput, valorInput });
    };
}

export function cambiarInputActivo(seccionInput, nombreInput) {
    return (dispatch, getState) => {
        _dispatch({ type: ASIENTOSCONTABLES_INPUT_ACTIVO, seccionInput, nombreInput });
    }
}

export function cambiarOpcionCombo(nombreCombo, valorCombo) {
    LogHelper.In(cambiarOpcionCombo.name, nombreCombo, valorCombo);
    return (dispatch) => {
        sessionStorage.setItem('PantallaCambios', true);
        _dispatch({ type: ASIENTOSCONTABLES_SELECCIONAR_OPCION_COMBO, nombreCombo, valorCombo });
    };
}

export function actualizarComentarios(comentarios) {
    return (dispatch) => {
        sessionStorage.setItem('PantallaCambios', true);
        dispatch({ type: ASIENTOSCONTABLES_ACTUALIZAR_COMENTARIOS, comentarios });
    };
}
/*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
++++++++++++++++++++++++++++FUNCIONES AUXILIARES++++++++++++++++++++++++++++
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
// Función para convertir fecha de "DD/MM/AAAA" a "AAAA-MM-DD"
function formatearFecha(fecha) {
    const partes = fecha.split('/');
    if (partes.length === 3) {
        const dia = partes[0];
        const mes = partes[1];
        const año = partes[2];
        return `${año}-${mes}-${dia}`;
    } else {
        // Devuelve null o maneja el formato incorrecto de otra manera.
        return null;
    }
}

function busquedaModelosContables(modelos, modelosSeleccionados, input) {
    if(modelosSeleccionados.length > 0) {
        //Se quitan los modelos que ya fueron seleccionados
        modelos = modelosSeleccionados[0]?.Id == "Todos" ? [] : modelos.filter(m => { return !modelosSeleccionados.some(ms => ms.Id == m.Id) });
    }

    return filtrarModelos(modelos, input);
}


function filtrarModelos(modelos, valorInput) {
    let modelosFiltradosBuscador = [];

    if(valorInput){
        let modelosFiltradosCodigo = modelos.filter( function(m) {
            let modelosFiltrados = m["Id"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

        let modelosFiltradosDescripcion = modelos.filter( function(m) {
            let modelosFiltrados = m["Descripcion"].toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            return modelosFiltrados.includes(valorInput.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
        });

         let modelosMergeados = [...modelosFiltradosCodigo, ...modelosFiltradosDescripcion];

         modelosFiltradosBuscador = [... new Set(modelosMergeados)];
    }
    else {
        modelosFiltradosBuscador = modelos;
    }

    return modelosFiltradosBuscador;
}

function validarFecha(fechaInput, fechaDesde, fechaHasta) {
    let resultadoError = {
        esError: false,
        mensaje: ""
    }
    const fechaActual = new Date();
    const anioMinimo = 1920;
    const anio = Number(fechaInput.split('/')[2]);
    const fechaDesde_obj = new Date(fechaDesde.split('/').reverse().join('-'));
    const fechaHasta_obj = new Date(fechaHasta.split('/').reverse().join('-'));

    if (fechaInput == "Fecha inválida") {
        resultadoError.esError = true;
        resultadoError.mensaje = "Formato o fecha inválida. Formato válido: DD/MM/AAAA";
    }

    // Validar año mínimo
    if (!resultadoError.esError && (anio < anioMinimo || anio > fechaActual.getFullYear())) {
        resultadoError.esError = true;
        resultadoError.mensaje = "Fecha inválida. El año debe estar entre 1920 y el año actual";
    }

    if(!resultadoError.esError && (fechaDesde_obj > fechaHasta_obj)) {
        resultadoError.esError = true;
        resultadoError.mensaje = "La Fecha Desde no puede ser mayor a la Fecha Hasta";
    }

    //Mantengo el error de las fechas en caso de que alguna siga con error
    if (fechaDesde == "Fecha inválida" || fechaHasta == "Fecha inválida") {
        resultadoError.mensaje = "Formato o fecha inválida. Formato válido: DD/MM/AAAA";
    }

    // Validar los rangos de fechas siempre y cuando ambas fechas tengan un formato válido
    if (fechaDesde != "Fecha inválida" && fechaHasta != "Fecha inválida") {
        resultadoError = validarRangoFechas(fechaDesde, fechaHasta, resultadoError);
    }

    return resultadoError;
}


// Función para validar un rango de fechas y asignar errores
function validarRangoFechas(fechaDesde, fechaHasta, resultadoError) {
    const fechaInicio = new Date(fechaDesde.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
    const fechaFin = new Date(fechaHasta.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));

    // Calcula la diferencia en días
    const diffTime = Math.abs(fechaFin - fechaInicio);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 30) {
        resultadoError.esError = true;
        resultadoError.mensaje = "El rango de fecha seleccionada no puede ser mayor a un mes";
    }

    return resultadoError;
}

function calcularTotal(renglones, moneda, tipoOperacion) {
    return renglones
        .filter(renglon => 
            (renglon.ModeloMonedaSalidaCodigo == moneda || renglon.MonedaSalidaCodigo == moneda) && 
            renglon.TipoOperacion == tipoOperacion
        )
        .reduce((total, renglon) => total + parseFloat(renglon.ImporteAsiento), 0);
}

//Función para armado de parámetros para OD de ""
function armarParametrosDataPantallaPrincipal(obtenerParamsState, informarRenglones) {
    let params = {
        "ADMINISTRADORA_ID": null,
        "CODIGOS_MODELOS": null,
        "FECHA_DESDE_CONTA": null,
        "FECHA_HASTA_CONTA": null,
        "FECHA_DESDE_VALOR": null,
        "FECHA_HASTA_VALOR": null,
        "SUCURSAL_ID": null,
        "ASIENTO_ID": null,
        "ASIENTO_ESTADO_ID": null,
        "MONEDA_ID": null,
        "FECHA_DESDE_RENDICION": null,
        "FECHA_HASTA_RENDICION": null,
        "NO_BALANCEADOS": 0,
        "INGRESADOS_MANUAL": 0,
        "CONFIRMADOS_MANUAL": 0,
        "BAJA": 0,
        "INFORMA_RENGLONES": 0
    }

    if(obtenerParamsState) {
        let xmlModelos = null;
        let modelosContablesSeleccionados = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables.modalSeleccionModelos.modelosContablesSeleccionados));
        let modelosContablesFiltrados = JSON.parse(JSON.stringify(_getState().asientosContables.inputsAsientosContables.modalSeleccionModelos.modelosContablesFiltrados));

        if (modelosContablesFiltrados.length === modelosContablesSeleccionados.length) {
            modelosContablesSeleccionados = null;
        } else {
            xmlModelos = '<Modelos>\n';

            for (var i = 0; i < modelosContablesSeleccionados.length; i++) {
                xmlModelos += '\t<Modelo Codigo="' + modelosContablesSeleccionados[i].Id + '" />\n';
            }

            xmlModelos += '</Modelos>';
        }

        let comboSucursal = parseInt(JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables.comboSucursal)));
        let comboEstado = parseInt(JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables.comboEstado)));
        let comboMoneda = parseInt(JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables.comboMoneda)));
        let comboMarca = parseInt(JSON.parse(JSON.stringify(_getState().asientosContables.combosAsientosContables.comboMarca)));
        let inputIdAsiento = !isNaN(_getState().asientosContables.inputsAsientosContables.inputIdAsiento) && _getState().asientosContables.inputsAsientosContables.inputIdAsiento !== ""
        ? parseInt(_getState().asientosContables.inputsAsientosContables.inputIdAsiento, 10)
        : null;    
        let checkSoloNoBalanceados = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkSoloNoBalanceados));
        let checkSoloIngresadosModificadosManualmente = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkSoloIngresadosModificadosManualmente));
        let checkSoloConfirmadosManualmente = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkSoloConfirmadosManualmente));
        let checkSoloDadosBaja = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkSoloDadosBaja));
        let inputFechaContabilizacionDesde = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaContabilizacionDesde);
        let inputFechaContabilizacionHasta = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaContabilizacionHasta);
        let inputFechaValorDesde = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaValorDesde);
        let inputFechaValorHasta = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaValorHasta);
        let inputFechaRendicionDesde = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaRendicionDesde);
        let inputFechaRendicionHasta = formatearFecha(_getState().asientosContables.inputsAsientosContables.inputFechaRendicionHasta);
        let checkFechaRendicion = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkFechaRendicion));
        let checkFechaContabilizacion = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkFechaContabilizacion));
        let checkFechaValor = JSON.parse(JSON.stringify(_getState().asientosContables.checksAsientosContables.checkFechaValor));

        comboSucursal = comboSucursal === 0 ? null : comboSucursal;
        comboMoneda = comboMoneda === 0 ? null : comboMoneda;
        comboEstado = comboEstado === 0 ? null : comboEstado;
        comboMarca = comboMarca === 0 ? null : comboMarca;

        params = {
            "ADMINISTRADORA_ID": comboMarca,
            "CODIGOS_MODELOS": xmlModelos,
            "FECHA_DESDE_CONTA": checkFechaContabilizacion ? inputFechaContabilizacionDesde : null,
            "FECHA_HASTA_CONTA": checkFechaContabilizacion ? inputFechaContabilizacionHasta : null,
            "FECHA_DESDE_VALOR": checkFechaValor ? inputFechaValorDesde : null,
            "FECHA_HASTA_VALOR": checkFechaValor ? inputFechaValorHasta : null,
            "SUCURSAL_ID": comboSucursal,
            "ASIENTO_ID": inputIdAsiento,
            "ASIENTO_ESTADO_ID": comboEstado,
            "MONEDA_ID": comboMoneda,
            "FECHA_DESDE_RENDICION": checkFechaRendicion ? inputFechaRendicionDesde : null,
            "FECHA_HASTA_RENDICION": checkFechaRendicion ? inputFechaRendicionHasta : null,
            "NO_BALANCEADOS": checkSoloNoBalanceados,
            "INGRESADOS_MANUAL": checkSoloIngresadosModificadosManualmente,
            "CONFIRMADOS_MANUAL": checkSoloConfirmadosManualmente,
            "BAJA": checkSoloDadosBaja,
            "INFORMA_RENGLONES": informarRenglones
        }
    }

    return params;
}